export const FETCH_PROJECTSUGGESTIONS_REQUEST = 'FETCH_PROJECTSUGGESTIONS_REQUEST';
export const FETCH_PROJECTSUGGESTIONS_SUCCESS = 'FETCH_PROJECTSUGGESTIONS_SUCCESS';
export const FETCH_PROJECTSUGGESTIONS_FAILURE = 'FETCH_PROJECTSUGGESTIONS_FAILURE';
export const CREATE_PROJECTSUGGESTION_REQUEST = 'CREATE_PROJECTSUGGESTION_REQUEST';
export const CREATE_PROJECTSUGGESTION_SUCCESS = 'CREATE_PROJECTSUGGESTION_SUCCESS';
export const CREATE_PROJECTSUGGESTION_FAILURE = 'CREATE_PROJECTSUGGESTION_FAILURE';
export const CREATE_PROJECTSUGGESTIONUPDATE_REQUEST = 'CREATE_PROJECTSUGGESTIONUPDATE_REQUEST';
export const CREATE_PROJECTSUGGESTIONUPDATE_SUCCESS = 'CREATE_PROJECTSUGGESTIONUPDATE_REQUEST';
export const CREATE_PROJECTSUGGESTIONUPDATE_FAILURE = 'CREATE_PROJECTSUGGESTIONUPDATE_REQUEST';